import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { motion, AnimatePresence } from 'framer-motion';
import { FaBars, FaTimes } from 'react-icons/fa';
import Logo from '../common/Logo';

const Header = () => {
  const { t, i18n } = useTranslation();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();

  const navItems = [
    { path: '/', text: 'home' },
    { path: '/about', text: 'about' },
    { path: '/services', text: 'services' },
    { path: '/courses', text: 'courses' },
    { path: '/scholarships', text: 'scholarships' },
    //{ path: '/events', text: 'events' },
    { path: '/contact', text: 'contact' },
    // { path: '/spenden', text: 'spenden' },
  ];

  const isRTL = i18n.language === 'ar';

  // Helper to check if a nav item is currently active
  const isActive = (path) =>
    path === '/'
      ? location.pathname === '/'
      : location.pathname.startsWith(path);

  return (
    <header
      className={`bg-white shadow-md sticky top-0 z-50 ${isRTL ? 'rtl' : ''}`}
    >
      <div className="container mx-auto px-4 py-3 flex justify-between items-center">
        {/* Logo - Clickable, go home */}
        <Link to="/" className="flex items-center">
          <Logo />
        </Link>

        {/* Desktop Navigation */}
        <nav className="hidden md:flex space-x-8 rtl:space-x-reverse">
          {navItems.map((item, index) => (
            <motion.div
              key={item.path}
              initial={{ opacity: 0, y: -10 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: index * 0.1 }}
            >
              <Link
                to={item.path}
                className={
                  `text-gray-800 hover:text-primary-600 font-medium transition-colors duration-150 ` +
                  (isActive(item.path)
                    ? 'border-b-2 border-accent-500 pb-2'
                    : 'border-b-2 border-transparent pb-2')
                }
              >
                {t(`nav.${item.text}`)}
              </Link>
            </motion.div>
          ))}
        </nav>

        {/* Mobile Menu Button */}
        <button
          className="md:hidden text-gray-800 focus:outline-none z-50"
          onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          aria-label="Toggle menu"
        >
          {mobileMenuOpen ? (
            <FaTimes size={24} />
          ) : (
            <FaBars size={24} />
          )}
        </button>

        {/* Mobile Menu */}
        <AnimatePresence>
          {mobileMenuOpen && (
            <motion.div
              initial={{ opacity: 0, x: isRTL ? '-100%' : '100%' }}
              animate={{ opacity: 1, x: 0 }}
              exit={{ opacity: 0, x: isRTL ? '-100%' : '100%' }}
              transition={{ type: 'tween' }}
              className={`fixed inset-0 bg-white z-40 pt-20 px-4 md:hidden text-center`}
            >
              <div className="flex flex-col space-y-6">
                {navItems.map((item) => (
                  <Link
                    key={item.path}
                    to={item.path}
                    className={
                      `text-2xl font-medium py-2 transition-colors duration-150 ` +
                      (isActive(item.path)
                        ? 'text-accent-500'
                        : 'text-gray-800')
                    }
                    onClick={() => setMobileMenuOpen(false)}
                  >
                    {t(`nav.${item.text}`)}
                  </Link>
                ))}
              </div>
            </motion.div>
          )}
        </AnimatePresence>
      </div>
    </header>
  );
};

export default Header;
